module.exports = __webpack_public_path__ + "static/oberhuber-jenal-logo-de-ecf1b98cece88e4d90350b1d2660ece0.svg";